import { environment as global } from './environment';

export const environment = {
  production: true,
  appTitle: 'endooControl',
  productVersion: '3.5.7'
};
